import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Navbar from './components/Navigation/Navbar';
import Breadcrumbs from './components/Navigation/Breadcrumbs';
import Footer from './components/Layout/Footer';
import Home from './pages/Home';
import About from './pages/About';
import TeamPage from './pages/About/Team';
import PartnersPage from './pages/About/Partners';
import CareersPage from './pages/About/Careers';
import FAQPage from './pages/About/FAQ';
import Capabilities from './pages/Capabilities';
import Research from './pages/Research';
import Insights from './pages/Insights';
import News from './pages/News';
import NewsDetail from './pages/News/components/NewsDetail';
import Events from './pages/Events';
import Contact from './pages/Contact/index';
import CAFPProgram from './components/Programs/CAFP';
import ClimateFinance from './pages/Capabilities/ClimateFinance';
import EnergyFinance from './pages/Capabilities/EnergyFinance';
import BiodiversityFinance from './pages/Capabilities/BiodiversityFinance';

export default function App() {
  return (
    <div className="min-h-screen bg-white flex flex-col">
      <Navbar />
      <Breadcrumbs />
      <main className="flex-grow flex flex-col">
        <Routes>
          <Route path="/" element={<Navigate to="/home" replace />} />
          <Route path="/home" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/about/team" element={<TeamPage />} />
          <Route path="/about/partners" element={<PartnersPage />} />
          <Route path="/about/careers" element={<CareersPage />} />
          <Route path="/about/faqs" element={<FAQPage />} />
          <Route path="/capabilities" element={<Capabilities />} />
          <Route path="/capabilities/climate-finance" element={<ClimateFinance />} />
          <Route path="/capabilities/energy-finance" element={<EnergyFinance />} />
          <Route path="/capabilities/biodiversity-finance" element={<BiodiversityFinance />} />
          <Route path="/research" element={<Research />} />
          <Route path="/insights" element={<Insights />} />
          <Route path="/news" element={<News />} />
          <Route path="/news/:slug" element={<NewsDetail />} />
          <Route path="/events" element={<Events />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/programs/cafp" element={<CAFPProgram />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}